export default __webpack_public_path__ + "static/media/Blade's Mask of the Silent Kill.83571449.jpg";